/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'
import { UiSelectOption } from '../UiSelectWithGraphics'
import UiSelectWithGraphicsGroupOptionsList from './UiSelectWithGraphicsGroupOptionsList'

interface UiSelectWithGraphicsGroupProps {
    group: { groupLabel: string; options: UiSelectOption[] }
}

const UiSelectWithGraphicsGroup: React.FC<UiSelectWithGraphicsGroupProps> = ({
    group,
}) => {
    return (
        <div className={clsx('UiSelectWithGraphicsGroup py-1')}>
            {!!group.groupLabel && (
                <div
                    className={clsx(
                        'px-3 py-1 text-[10px] uppercase tracking-wide text-gray-600 dark:text-gray-400'
                    )}
                >
                    {group.groupLabel}
                </div>
            )}
            <UiSelectWithGraphicsGroupOptionsList options={group.options} />
        </div>
    )
}

export default UiSelectWithGraphicsGroup
